const rules = {
  // سرپرست انبار
  WAREHOUSE_SUPERVISOR: {
    static: [
      '/login',
      '/warehouses-menu',
      '/warehouses',
      '/warehouses/:id',
      '/warehouses/details/:id',
      '/warehouses/assign-user/:id',
      '/warehouses/children/:warehousesId',
      '/warehouses/inventory',
      '/warehouses/inventory/:warehousesId',
      '/warehouses/inventory/:warehousesId/log/:skuId',
      '/skus/inventory/:skuId/:name',
      '/centersStatistics',
      '/centersStatistics/details/:id/:nameCenter',
      '/inventry-items/:id',
      '/parcels',
      '/parcels/details/:id',
      '/profile',
    ],
  },
  // ادمین انبار
  WAREHOUSE_ADMIN: {
    static: [
      '/login',
      '/assign-order/:id',
      '/parcels/receipts/:id',
      '/parcels/outgoing-receipts/:id',
      '/warehouse-admin-orders',
      '/warehouse/inventory',
      '/warehouses/product-history',
      '/warehouse-admin-canceled-orders',
      '/assign-cancellation-order/:id',
      '/print-labels/:id',
      '/orders/:id',
      '/orders/:id/allLogs',
      'orders-info:more-info',
      'post-orders:detail',
      'orders:history',
      'orders:detail:inventory-items',
      'orders:changeOrderStatus',
      'order:assign',
      '/orders/exit-receipts/:id',
      'orderExit:print',
      'orders:addParcel',
      'orders:downloadReportCSV',
      'orders:tracking-code',
      '/orders/receipts/:id',
      '/orders/receipt/bulk',
      '/parcels-operators/:id/warehouse/:warehouseId',
      '/warehouses/your-inventory/log/:id',
      '/parcels-sender-operators/:id/warehouse/:warehouseId',
      '/warehouse-zones',
      '/warehouse-zones/aisle/:id',
      '/warehouse-zones/unit/:id',
      '/warehouse-zones/row/:id',
      'warehouse-zone-row:add',
      'warehouse-zone-row:edit',
      'warehouse-zone-row:changeStatus',
      '/warehouse-zones/column/:id',
      'warehouse-zone-column:add',
      'warehouse-zone-column:edit',
      'warehouse-zone-column:changeStatus',
      'warehouse-zone-aisles:add',
      'warehouse-zone-aisles:edit',
      'warehouse-zone-aisles:changeStatus',
      '/warehouse-zones/aisle/:id',
      '/warehouse-zones',
      'warehouse-zones:add',
      'warehouse-zones:edit',
      'warehouse-zones:changeStatus',
      '/warehouses/your-inventory',
      '/warehouses/inventory/:warehousesId/log/:skuId',
      '/parcels/:id/allLogs',
      '/parcels/details/:id',
      'parcels-details:print',
      '/parcels-sender',
      '/parcels-exit/add',
      '/parcels-exit/details/:id',
      '/parcels-warehouse/details/:id',
      '/parcels-partner/details/:id',
      '/parcels-sender:editParcel',
      '/warehouse-admin-parcels-receipts',
      'parcels:addParcel',
      'parcels-sender:changeStatus',
      '/parcel/:id/unload-inventory-items',
      '/parcel/:id/locate-inventory-items',
      'parcels-detail:downloadCSV',
      'skus:downloadCSV',
      'parcels-detail:downloadInventoryItemCSV',
      '/warehouse-admin-user',
      'user:createNewUser',
      '/edit-product/:id',
      '/packing-management',
      '/parcel/:id/inventory-items/submit',
      '/parcel/:id/inventory-items',
      '/edit-product/:id',
      '/quarantine-warehouse',
      '/parcels-quarantine/details/:id',
      '/parcels-quarantine/add',
      '/profile',
      '/dimension',
      "locate:group",
      "register:group",
      "relocate:unit",
      '/relocate/by-item',
      '/operator-assignment',
      '/ticketing',
      '/ticketing/:id',
      'locate:detail',
      'conflict:detail'
    ],
  },
  WAREHOUSE_OPERATOR: {
    static: [
      '/',
      '/login',
      '/print-labels/:id',
      '/canceled-orders',
      '/parcels-warehouse-operator',
      '/parcels-warehouse-operator-mob',
      '/parcel/:id/inventory-items',
      'parcel:inventory-items',
      '/parcels/receipts/:id',
      '/parcels/outgoing-receipts/:id',
      '/parcels/details/:id',
      '/parcel-item/details/:id',
      '/parcel-item-mob/details/:id',
      '/parcels/:id/allLogs',
      '/parcel/:id/locate-inventory-items',
      '/order/:id/cancellation/:cancellationId/locate-inventory-items',
      '/parcel/:id/unload-inventory-items',
      '/parcels/receipts/:id',
      '/orders/:id',
      'orders:tracking-code',
      'orders-info:more-info',
      '/orders/:id/allLogs',
      '/orders/receipts/:id',
      'orders:history',
      '/warehouse-operator-orders-mob',
      '/warehouse-operator-orders/:id/pick',
      '/warehouse-operator-orders/:id/pack',
      '/warehouse-operator-orders',
      '/relocate',
      '/relocate/by-item',
      '/relocate/by-unit',
      '/orders/exit-receipts/:id',
      '/parcel/:id/inventory-items/submit',
      '/edit-product/:id',
      '/mobile-home',
      '/orders-mob/:id',
      '/parcels-mob/details/:id',
      '/profile',
      '/dimension',
      '/ticketing/:id',
      'orderExit:print'
    ],
  },
  EXCHANGE_ADMIN: {
    static: [
      '/',
      '/login',
      '/bundles-deliver',
      '/bundles/:id',
      '/bundles/:id/allLogs',
      'bundles:history',
      'bundles:deliverToDriver',
      '/bundles/:id/deliver-driver',
      '/organize-bundles',
      '/orders/:id',
      '/deliver-driver-receipt/:id',
      '/deliver/receipts/:id',
      '/depo-deliver',
      '/create-grouping-order',
      '/bundles/:id/driver',
      '/bundles/:id/driver/:vehicleId/entrance/:entranceId',
      'bundles:add',
      'bundles:add-exel',
      '/create-bundle',
      '/create-bundle-with-excel',
      '/edit-bundle/:id',
      '/3pl-print-labels',
      '/profile',
    ],
  },
  NONE: {
    static: ['/login'],
  },
};

export default rules;
